import { ViewFactory } from 'wdc-cube-react'
import UserChangePasswordScope from '../ucp_form_scope'
import UserChangePasswordFormView from './ucp_form_view'

export function registerViews(rv = ViewFactory.register) {
    rv(UserChangePasswordScope, UserChangePasswordFormView)
}
